import { render, staticRenderFns } from "./ChooseAppointment.vue?vue&type=template&id=fa3f71ba&scoped=true"
import script from "./ChooseAppointment.vue?vue&type=script&lang=js"
export * from "./ChooseAppointment.vue?vue&type=script&lang=js"
import style0 from "./ChooseAppointment.vue?vue&type=style&index=0&id=fa3f71ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3f71ba",
  null
  
)

export default component.exports